import React, { createContext, useEffect, useState, useContext } from "react";
import LogoLoader from "../components/LogoLoader";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    try {
      if (storedUser && storedUser !== "undefined") {
        setUser(JSON.parse(storedUser));
      }
    } catch (err) {
      console.error("Invalid user data in localStorage:", err);
      localStorage.removeItem("user");
    }

    setLoading(false);
  }, []);


  const login = (userData) => {
    const flat = { token: userData.token, ...(userData.user || {}) };
    localStorage.setItem("user", JSON.stringify(flat));
    if (userData?.user?.role) {
      localStorage.setItem("userRole", userData.user.role);
    }
    setUser(flat);
  };

  const logout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {loading ? <LogoLoader /> : children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
